<template>
    <CContainer fluid class="px-0">
        <CRow :form="true">
            <CCol sm="12">
                <CInput
                    :value.sync="valueComponent.user"
                    :label="$t('User')"
                    :placeholder="$t('Enter your user name')"
                    :invalidFeedback="$t('User name is required')"
                    size="sm"
                />
            </CCol>
            <CCol sm="12">
                <CCInputPassword
                    :value.sync="valueComponent.password"
                    :label="$t('Password')"
                    :placeholder="$t('Enter your password')"
                    :invalidFeedback="$t('Password is required')"
                    size="sm"
                />
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>

import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import CCInputPassword from "~/components/CCInputPassword.vue";

export default {
    name: "CCSftpCredentials",
    mixins: [],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    consts: {},
    options: {},
    components: {
        CCInputPassword
    },
    data() {
        return {
            valueComponent: {
                user: null,
                password: null
            }
        };
    },
    props: {
        value: {
            required: true,
        },
        encode: {
            default: false,
        },
    },
    watch: {
        value(newValue) {
            if (this.encode) {
                if (newValue) {
                    const valueParsed = JSON.parse(newValue);
                    this.handleComponentValue(valueParsed);
                }
            } else {
                this.valueComponent = newValue;
            }
        },

        valueComponent: {
            handler(newValue) {
                this.emitChangeValue();
            },
            deep: true,
        },
    },
    methods: {
        getValue() {
            if (this.encode) {
                return JSON.stringify(this.valueComponent);
            }
            return this.valueComponent;
        },
        emitChangeValue() {
            this.$emit("update:value", this.getValue());
            this.$emit("change", this.getValue());
        },
        handleComponentValue(value) {
            let newValueComponent = {};
            for (const key in this.valueComponent) {
                if (Object.hasOwnProperty.call(value, key)) {
                    if (Array.isArray(value[key])) {
                        newValueComponent = {
                            ...newValueComponent,
                            [key]: [...value[key]],
                        };
                    } else {
                        newValueComponent = {
                            ...newValueComponent,
                            [key]: value[key],
                        };
                    }
                }
            }

            this.valueComponent = newValueComponent;
        },
    },
    async mounted() {
        if (this.encode) {
            if (this.value) {
                const valueParsed = JSON.parse(this.value);
                this.handleComponentValue(valueParsed);
            } else {
                // Emitimos el modelo por defecto de value en caso de que el valor sea vacio para mantener el formato
                // Solo lo haremos al momento de hacer el mounted del componente
                this.emitChangeValue();
            }
        } else {
            this.valueComponent = this.value;
        }
    },
};
</script>

<style>
.range__not_defined {
    accent-color: gray;
}
</style>
